<script>
  /** @type {{ label: string, value: string }} */
  const { label, value } = $props();
</script>

<div class="key-value-item">
  <div class="key-value-label">{label}</div>
  <div class="key-value-value">
    {value}
  </div>
</div>

<style>
  .key-value-item:not(:first-child) {
    border-top: solid 2px var(--color-white);
    padding-top: var(--spacing-4);
  }
  .key-value-label {
    font-size: var(--font-size-normal);
    font-weight: var(--font-weight-bold);
    margin-bottom: var(--spacing-2);
  }
  .key-value-value {
    font-size: var(--font-size-small);
  }
</style>
